module.exports = __webpack_public_path__ + "img/CC-Logo-Blue.0b0d33c2.svg";